import React, { useState, useEffect } from "react";
import {
  Container,
  MenuItem,
  Select,
  Button,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import axios from "axios";
import { saveAs } from "file-saver";
import BASE_URL from "../config";
const FeeReportPage = () => {
  const [reportType, setReportType] = useState("");
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/coursesss`)
      .then((res) => {
        setCourses(res.data);
      })
      .catch((err) => console.error("Error fetching courses:", err));
  }, []);
  useEffect(() => {
  if (reportType === "CategoryWise" && selectedCourse) {
    axios
      .get(`${BASE_URL}/api/categories?course=${selectedCourse}`)
      .then((res) => setCategories(res.data))
      .catch((err) => console.error("Error fetching categories:", err));
  }
}, [reportType, selectedCourse]);
  const handleCourseChange = async (courseId) => {
    setSelectedCourse(courseId);
    if (reportType !== "") {
      const yearRes = await axios.get(
        `${BASE_URL}/api/academic-yearsss?course=${courseId}`
      );
      setAcademicYears(yearRes.data);
    }
    if (reportType === "ByClass" || reportType === "CategoryWise" || reportType === "FeeBetweenDate" || reportType === "ConcessionReport") {
      const classRes = await axios.get(
        `${BASE_URL}/api/classes?course=${courseId}`
      );
      setClasses(classRes.data);
    }
  };
  const handleExport = async () => {
   /*  if  */
   /*  (
      !reportType ||
      !selectedCourse ||
      !selectedYear ||
      (!selectedClass && reportType !== "AllClass")
    )  */
   if (
  !reportType ||
  !selectedCourse ||
  !selectedYear
) 
{
  alert("Please select required fields");
  return;
}

if (
  reportType === "ByClass" &&
  !selectedClass
) {
  alert("Please select Class");
  return;
}
    /* {
      alert("Please select all required fields.");
      return;
    } */
    try {
      const response = await axios.post(
        `${BASE_URL}/api/export-excel`,
        {
          reportType,
          courseID: selectedCourse,
          academicYearID: selectedYear,
         /*  classID: selectedClass,
          categoryID: selectedCategory, */
          classID: selectedClass || null,
          categoryID: selectedCategory || null,
        },
        { responseType: "blob" } // Important for handling binary files
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Fee_Report.xlsx");
    } catch (error) {
      console.error("Error exporting report:", error);
    }
  };
  const handleExportt = async () => {
    if (!startDate || !endDate || !selectedCourse || !selectedYear) {
      alert("Please select Course,AcademicYear with start and end dates.");
      return;
    }
    try {
      const response = await axios.post(
        `${BASE_URL}/api/export-fee-between-date`,
        { reportType, startDate, endDate,
        courseID: selectedCourse,
        academicYearID: selectedYear,
        classID: selectedClass || undefined,
       },
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Fee_Report.xlsx");
    } catch (error) {
      console.error("Error exporting report:", error);
    }
  };
  const handleExportConcession = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/export-concession-report`,
        {
          courseID: selectedCourse || null,
          academicYearID: selectedYear || null,
          classID: selectedClass || null,
          startDate: startDate || null,
          endDate: endDate || null,
        },
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Concession_Report.xlsx");
    } catch (error) {
      console.error("Error exporting concession report:", error);
    }
  };
  return (
    <Container>
      <h2>Fee Report</h2>
      <FormControl fullWidth margin="normal">
        <InputLabel>Report Type</InputLabel>
        <Select
          value={reportType}
          onChange={(e) => setReportType(e.target.value)}
        >
          <MenuItem value="CategoryWise">Category Wise</MenuItem>
          <MenuItem value="ByClass">By Class</MenuItem>
          <MenuItem value="AllClass">All Class</MenuItem>
          <MenuItem value="FeeBetweenDate">Fee Between Dates</MenuItem>
          <MenuItem value="ConcessionReport">Concession Report</MenuItem>
        </Select>
      </FormControl>
 {reportType === "ConcessionReport" && (
        <>
          <FormControl fullWidth margin="normal">
            <InputLabel>Course (Optional)</InputLabel>
            <Select
              value={selectedCourse}
              onChange={(e) => handleCourseChange(e.target.value)}
            >
              {courses.map((course) => (
                <MenuItem key={course.CourseID} value={course.CourseID}>
                  {course.CourseName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel>Academic Year (Optional)</InputLabel>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {academicYears.map((year) => (
                <MenuItem key={year.id} value={year.id}>
                  {year.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel>Class (Optional)</InputLabel>
            <Select
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
            >
              {classes.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>
                  {cls.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            margin="normal"
            label="Start Date (Optional)"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <TextField
            fullWidth
            margin="normal"
            label="End Date (Optional)"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleExportConcession}
            style={{ marginTop: "20px" }}
          >
            Export Concession Report
          </Button>
        </>
      )}
      {(reportType === "FeeBetweenDate") && (
  <>
    <FormControl fullWidth margin="normal">
      <InputLabel>Course</InputLabel>
      <Select
        value={selectedCourse}
        onChange={(e) => handleCourseChange(e.target.value)}
      >
        {courses.map((course) => (
          <MenuItem key={course.CourseID} value={course.CourseID}>
            {course.CourseName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl fullWidth margin="normal">
      <InputLabel>Academic Year</InputLabel>
      <Select
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
      >
        {academicYears.map((year) => (
          <MenuItem key={year.id} value={year.id}>
            {year.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl fullWidth margin="normal">
      <InputLabel>Class (Optional)</InputLabel>
      <Select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
          >
            {classes.map((cls) => (
              <MenuItem key={cls.id} value={cls.id}>
                {cls.name}
              </MenuItem>
            ))}
          </Select>
    </FormControl>
  </>
)}
      {reportType !== "FeeBetweenDate" && reportType !== "ConcessionReport" && (
        <FormControl fullWidth margin="normal">
          <InputLabel>Course</InputLabel>
          <Select
            value={selectedCourse}
            onChange={(e) => handleCourseChange(e.target.value)}
          >
            {courses.map((course) => (
              <MenuItem key={course.CourseID} value={course.CourseID}>
                {course.CourseName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {(reportType === "ByClass" ||
        reportType === "AllClass" ||
        reportType === "CategoryWise") && (
        <FormControl fullWidth margin="normal">
          <InputLabel>Academic Year</InputLabel>
          <Select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {academicYears.map((year) => (
              <MenuItem key={year.id} value={year.id}>
                {year.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {(reportType === "ByClass" || reportType === "CategoryWise") && (
        <FormControl fullWidth margin="normal">
          <InputLabel>Class</InputLabel>
          <Select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
          >
            {classes.map((cls) => (
              <MenuItem key={cls.id} value={cls.id}>
                {cls.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {reportType === "CategoryWise" && (
        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {reportType === "FeeBetweenDate" && (
        <>
          <TextField
            fullWidth
            margin="normal"
            label="Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <TextField
            fullWidth
            margin="normal"
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </>
      )}
      {reportType !== "FeeBetweenDate" && reportType !== "ConcessionReport" && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleExport}
          style={{ marginTop: "20px" }}
        >
          Export to Excel
        </Button>
      )}
      {reportType === "FeeBetweenDate" && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleExportt}
          style={{ marginTop: "20px" }}
        >
          Export FeeBetweenDate
        </Button>
      )}
    </Container>
  );
};
export default FeeReportPage;
